export default {
  /* eslint-disable no-useless-escape */
  AN: /[^a-zA-Z0-9-\._]+/g,
  /* eslint-disable no-useless-escape */
  N: /[^\d-]+/g,
  A: /[^a-zA-Z-\._]+/g,
  ALL: /[^a-zA-Z0-9]*$/,
};
